// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"b192dc47","787":"a8adf915","921":"c8f4de95"}[chunkId] + ".chunk.js";
};